import {IconRocket, IconHome, IconCalendarEvent, IconSettings} from '@tabler/icons-react';
import {NavLink} from 'react-router-dom';

export const Nav = () => {

    return (
        <header className="navbar navbar-expand-md d-print-none">
            <div className="container-xl">
                <button className="navbar-toggler" type="button"><span className="navbar-toggler-icon"></span></button>
                <div className="navbar-collapse collapse">
                    <div
                        className="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center justify-between">
                        <ul className="navbar-nav flex-grow-1">
                            <li className="nav-item me-1">
                                <NavLink to="/" className="nav-link">
                                    <IconCalendarEvent />
                                    <span className="nav-link-title ms-2">Events</span>
                                </NavLink>

                            </li>
                            <li className="nav-item me-1">
                                <NavLink to="/settings" className="nav-link">
                                    <IconSettings />
                                    <span className="nav-link-title ms-2">Settings</span>
                                </NavLink>

                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
};